// @flow
export { default } from './QuoteTags';



// WEBPACK FOOTER //
// ./src/components/quote/QuoteTags/index.js